import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import "material-design-icons-iconfont/dist/material-design-icons.css"; // Ensure you are using css-loader
import "vuetify/dist/vuetify.min.css"; // Ensure you are using css-loader
import store from "./store";

Vue.config.productionTip = false;
Vue.use(VueRouter);

import Leaderboard from "./components/Leaderboard.vue";
import Profile from "./components/Profile.vue";
import Callback from "./components/Callback.vue";
import SubmitYourOwn from "./components/SubmitYourOwn.vue";
import vuetify from "./plugins/vuetify";

const routes = [
    { path: "/", component: Leaderboard },
    { path: "/leaderboard", component: Leaderboard },
    { path: "/submityourown", component: SubmitYourOwn },
    { path: "/callback", component: Callback },
    {
        path: "/profile/:userHash",
        component: Profile,
        props: (route) => {
            return { userHash: route.params.userHash };
        }
    },
    {
        path: "/profile/",
        component: Profile,
        props: () => {
            return { userHash: false };
        }
    }
];

const router = new VueRouter({
    mode: "history",
    base: "/puzzleoftheday",
    routes // short for `routes: routes`
});

export { router };

new Vue({
    store,
    router,
    vuetify,
    render: (h) => h(App)
}).$mount("#app");
